import { useEffect, useState } from 'react'

import { MenuInnerWithSub } from './MenuInnerWithSub'
import { MenuItem } from './MenuItem'
import { useAuth } from '../../../modules/auth'
import { useLayout } from '../../core'

export function MenuInner() {
  return (
    <>
      <DesignerMenu />
    </>
  )
}

const DesignerMenu = () => {
  const { user, siteId } = useAuth()
  const { config } = useLayout()

  const [allowDesign, setAllowDesign] = useState<boolean>(false)

  useEffect(() => {
    if (!user) return
    const allow = user.roles.indexOf('SUPER') !== -1
    setAllowDesign(allow)
  }, [user])

  return <>
    {(allowDesign === true && !config.aside.display) && <>
      <MenuInnerWithSub
        title='Site Content'
        to='#'
        menuPlacement='bottom-start'
        hasArrow={true}
        menuTrigger='click'
      >
        <MenuItem to={`/site(${siteId})/site-pages`} title="Site Pages" hasBullet={true} />
        <MenuItem to={`/site(${siteId})/components`} title="Components" hasBullet={true} />
        <MenuItem to={`/users`} title="Users" hasBullet={true} />
      </MenuInnerWithSub>
    </>}
  </>
}